"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "cn";
import * as React from "react";

/** Line-art strokes of the brand pattern, exported from Figma at 268×900. */
const PATTERN_STROKES = ["M223.726 251.836L212.052 319.681", "M174.382 321.822L177.069 390.605", "M140.67 400.529L157.604 467.256", "M124.061 484.525L154.49 546.269", "M125.273 570.151L167.881 624.221", "M144.252 653.647L197.178 697.672", "M180.179 731.368L241.085 763.43", "M231.476 799.923L297.734 818.62", "M286.554 193.631L261.029 257.575", "M860.599 824.376C1027.94 642.774 1016.38 359.901 834.777 192.56C653.175 25.2195 370.301 36.7804 202.961 218.382C35.6202 399.984 47.181 682.857 228.783 850.198C410.384 1017.54 693.258 1005.98 860.599 824.376Z", "M833.071 799.027C986.411 632.619 975.817 373.413 809.409 220.073C643.002 66.7328 383.795 77.3264 230.455 243.734C77.1151 410.142 87.7087 669.349 254.116 822.688C420.524 976.028 679.731 965.435 833.071 799.027Z", "M533.636 50.7344C647.077 51.1534 760.704 92.3413 850.701 175.271C1041.85 351.411 1054.02 649.162 877.881 840.313C701.742 1031.46 403.991 1043.63 212.84 867.493C21.6892 691.353 9.52053 393.602 185.66 202.451C267.213 113.948 374.827 63.8199 485.862 52.9774", "M330.134 -30.127C621.557 -125.152 934.839 34.0554 1029.86 325.478C1124.89 616.901 965.682 930.183 674.259 1025.21C408.748 1111.79 125.09 987.33 4.88454 744.119", "M177.12 194.566C181.222 190.114 180.939 183.179 176.487 179.077C172.035 174.975 165.1 175.258 160.998 179.71C156.896 184.162 157.179 191.096 161.631 195.199C166.083 199.301 173.017 199.017 177.12 194.566Z", "M91.5962 323C95.6985 318.548 95.4151 311.613 90.9632 307.511C86.5113 303.409 79.5769 303.692 75.4747 308.144C71.3724 312.596 71.6558 319.53 76.1077 323.633C80.5595 327.735 87.494 327.451 91.5962 323Z", "M49.9441 471.569C54.0463 467.117 53.7629 460.183 49.3111 456.08C44.8592 451.978 37.9248 452.261 33.8225 456.713C29.7202 461.165 30.0034 468.1 34.4553 472.202C38.9072 476.304 45.8418 476.021 49.9441 471.569Z", "M56.237 625.73C60.3393 621.278 60.0559 614.344 55.604 610.242C51.1522 606.139 44.2176 606.423 40.1153 610.875C36.013 615.326 36.2966 622.261 40.7485 626.363C45.2004 630.466 52.1348 630.182 56.237 625.73Z", "M109.874 770.406C113.976 765.954 113.692 759.02 109.241 754.917C104.789 750.815 97.8543 751.098 93.752 755.55C89.6497 760.002 89.9331 766.937 94.385 771.039C98.8369 775.141 105.771 774.858 109.874 770.406Z", "M205.599 891.428C209.701 886.976 209.417 880.041 204.965 875.939C200.513 871.837 193.579 872.12 189.477 876.572C185.374 881.024 185.658 887.958 190.11 892.06C194.562 896.163 201.496 895.88 205.599 891.428Z", "M437.003 419.744L237.987 236.357L223.723 251.837L422.738 435.224C424.907 432.491 427.143 429.792 429.542 427.188C431.942 424.584 434.449 422.121 436.996 419.751L437.003 419.744Z", "M185.114 303.709L174.377 321.812L407.157 459.803C410.236 453.568 413.824 447.524 417.901 441.707L185.114 303.709Z", "M147.405 380.578L140.666 400.523L397.042 487.098C398.755 480.331 401.01 473.659 403.766 467.154L147.405 380.578Z", "M126.489 463.616L124.053 484.525L392.912 515.919C393.185 508.913 393.974 501.922 395.296 495.004L126.489 463.616Z", "M392.827 523.993L123.296 549.186L125.256 570.141L394.802 544.947C393.61 538.015 392.961 531.011 392.827 523.993Z", "M137.994 633.542L144.27 653.63L402.678 572.941C400.064 566.387 397.974 559.674 396.395 552.846L137.993 633.527L137.994 633.542Z", "M169.892 713.013L180.208 731.367L416.27 598.671C412.317 592.782 408.864 586.655 405.911 580.347L169.892 713.013Z", "M217.61 784.109L231.518 799.912L434.908 620.976C429.788 616.007 425.142 610.734 420.958 605.218L217.624 784.108L217.61 784.109Z", "M279.058 843.74L295.943 856.313L457.699 638.984C451.839 635.287 446.191 631.102 440.8 626.427L279.051 843.748L279.058 843.74Z", "M303.727 181.461L286.56 193.638L443.094 414.388C448.566 409.843 454.298 405.773 460.253 402.203L303.727 181.461Z"];

/**
 * Decorative brand pattern drawn behind the app sidebar. Strokes use
 * `currentColor`, and the gradient mask fades the pattern out towards the top.
 */
function AppSidebarPattern(t0) {
  const $ = _c(38);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const t1 = React.useId();
  let t2;
  if ($[3] !== t1) {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = /[^\w-]/g;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = t1.replace(t3, "");
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const id = `app-sidebar-pattern${t2}`;
  const fadeMask = `${id}-fade`;
  const clipMask = `${id}-clip`;
  const fadeGradient = `${id}-gradient`;
  let t3;
  if ($[6] !== className) {
    t3 = cn("pointer-events-none", className);
    $[6] = className;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      maskType: "alpha"
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `url(#${fadeGradient})`;
  let t6;
  if ($[9] !== t5) {
    t6 = <rect y="-83" width="1256" height="983" fill={t5} />;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== fadeMask || $[12] !== t6) {
    t7 = <mask id={fadeMask} style={t4} maskUnits="userSpaceOnUse" x="0" y="-83" width="1256" height="983">{t6}</mask>;
    $[11] = fadeMask;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = `url(#${fadeMask})`;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      mixBlendMode: "hard-light"
    };
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      maskType: "luminance"
    };
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <path d="M496.09 -365.628L-355.189 558.199L133.178 1008.22L984.458 84.3887L496.09 -365.628Z" fill="white" />;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== clipMask) {
    t12 = <mask id={clipMask} style={t10} maskUnits="userSpaceOnUse" x="-356" y="-366" width="1341" height="1375">{t11}</mask>;
    $[17] = clipMask;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const t13 = `url(#${clipMask})`;
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = PATTERN_STROKES.map(_temp);
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t13) {
    t15 = <g mask={t13} stroke="currentColor" strokeWidth="0.25" strokeMiterlimit="10">{t14}</g>;
    $[20] = t13;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t12 || $[23] !== t15) {
    t16 = <g style={t9} opacity="0.53">{t12}{t15}</g>;
    $[22] = t12;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t16 || $[26] !== t8) {
    t17 = <g mask={t8}>{t16}</g>;
    $[25] = t16;
    $[26] = t8;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  let t19;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <stop stopColor="white" stopOpacity="0" />;
    t19 = <stop offset="1" stopColor="white" />;
    $[28] = t18;
    $[29] = t19;
  } else {
    t18 = $[28];
    t19 = $[29];
  }
  let t20;
  if ($[30] !== fadeGradient) {
    t20 = <defs><linearGradient id={fadeGradient} x1="287" y1="78.5" x2="47.3213" y2="498.226" gradientUnits="userSpaceOnUse">{t18}{t19}</linearGradient></defs>;
    $[30] = fadeGradient;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] !== props || $[33] !== t17 || $[34] !== t20 || $[35] !== t3 || $[36] !== t7) {
    t21 = <svg xmlns="http://www.w3.org/2000/svg" width="268" height="900" viewBox="0 0 268 900" fill="none" aria-hidden="true" focusable="false" data-slot="app-sidebar-pattern" className={t3} {...props}>{t7}{t17}{t20}</svg>;
    $[32] = props;
    $[33] = t17;
    $[34] = t20;
    $[35] = t3;
    $[36] = t7;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  return t21;
}
function _temp(d) {
  return <path key={d} d={d} />;
}
export { AppSidebarPattern };